import * as THREE from "three";
import { scene } from "./scene";
import { progressbar } from "./progressbar";
import { ControlFunction } from "./controlFunction";

let clockMesh, clockMaterial, clockCanvas, clockContext, clockTexture;

const loadRealClock = () => {
    return new Promise((resolve) => {
        // 1. Create Canvas for Texture
        clockCanvas = document.createElement('canvas');
        clockCanvas.width = 512;
        clockCanvas.height = 128; // Rectangular shape for HH:MM:SS
        clockContext = clockCanvas.getContext('2d');

        clockTexture = new THREE.CanvasTexture(clockCanvas);

        // 2. Clock Body (The frame)
        const frameGeom = new THREE.BoxGeometry(0.8, 0.3, 0.05);
        const frameMat = new THREE.MeshStandardMaterial({
            color: 0x222222,
            metalness: 0.8,
            roughness: 0.2
        });
        const clockGroup = new THREE.Group();
        const frame = new THREE.Mesh(frameGeom, frameMat);
        clockGroup.add(frame);

        // 3. Clock Screen (The display)
        const screenGeom = new THREE.PlaneGeometry(0.75, 0.25);
        clockMaterial = new THREE.MeshBasicMaterial({
            map: clockTexture,
            transparent: true,
            opacity: 0.9
        });
        const screen = new THREE.Mesh(screenGeom, clockMaterial);
        screen.position.z = 0.026; // Slightly in front of frame
        clockGroup.add(screen);

        // 4. Position and Rotation
        // Visible starting position for the user to move it
        clockGroup.position.set(-3.9285818855103676, 3.3641894281740816, 3.854203581584393);
        clockGroup.scale.set(0.90, 0.90, 0.90);

        // Face forward (-Z direction)
        clockGroup.rotation.y = 0;

        scene.add(clockGroup);
        clockMesh = clockGroup;

        // Enable ControlFunction so you can move it with the mouse
        //ControlFunction(clockGroup);

        // Start the update loop
        updateClock();

        resolve(clockGroup);
        progressbar();
    });
};

const updateClock = () => {
    if (!clockContext) return;

    const now = new Date();
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    const timeString = `${hours}:${minutes}:${seconds}`;

    // Clear Canvas
    clockContext.clearRect(0, 0, clockCanvas.width, clockCanvas.height);

    // Draw Background
    clockContext.fillStyle = 'rgba(0, 0, 0, 0.8)';
    clockContext.fillRect(0, 0, clockCanvas.width, clockCanvas.height);

    // Draw Glow/Neon Effect
    clockContext.shadowColor = '#00f2ff';
    clockContext.shadowBlur = 15;
    clockContext.fillStyle = '#00f2ff';

    // Draw Text
    clockContext.font = 'bold 80px Courier New';
    clockContext.textAlign = 'center';
    clockContext.textBaseline = 'middle';
    clockContext.fillText(timeString, clockCanvas.width / 2, clockCanvas.height / 2);

    // Update Texture
    clockTexture.needsUpdate = true;

    // Schedule next update (once per second is enough)
    setTimeout(updateClock, 1000);
};

export { loadRealClock };
